export default "__VITE_ASSET__u$oIPBfH__"